export const staffData = {
	"directors": {
        "name": "Directors",
        "nameJp":"区樹差",
        "color": "#E0598B",
        "staff": [
            {
                "name": "Lotus",
                "slug": "lotus",
                "bio": "<i>Aika Dream On~ ☆</i> Eh? That’s right! The director of Dream Flower is Aika Mujika in the flesh! This project was one of my biggest dreams and I decided to make it a reality. I couldn’t have done it without ALL of our staff! Outside of the group, I am a voice actress and voice designer. Some of you might also recognise me by my Vtuber persona <a href='https://www.twitch.tv/nekohimelotus' target='_blank'>NekoHimeLotus</a>, under which I stream pretty often!",
                "bioJp": "とろゃ留擢すゅ都まのねてせく阿列へんちむひた絵派ゅんややゃるやんふ区樹差派鵜おしねやちぬ二擢ハケマリカ夜夜魔や野鵜課以ねオツヨユ列目やうるやはえねりメレアナ、けらた区二個ロテホネタ、日露ねふゃっふたゆち譜以遊二派遊舳巣けの差二個夜野二む樹離氏キテテミりそ等鵜擢夜つうと氏氏譜列アセオケホユ樹瀬はくみニトマケリ。",
                "color": "#E0598B",
                "link": "https://nekohimelotus.carrd.co/",
                "twitter": "https://twitter.com/nekohimelotus/",
                "socialMedia": 
                    {
                        "x":"https://twitter.com/nekohimelotus/", 
                        "carrd":"https://nekohimelotus.carrd.co/", 
                        "twitch": "https://www.twitch.tv/nekohimelotus",
                        "youtube": "https://www.youtube.com/channel/UC1fXkz2FC0c8YjTZEpD1ScA"
                    },
                "rolePrimary": "Lead director",
                "rolePrimaryJp": "のねてせく",
                "rolePrimarySlug":"lotus",
                "roleSecondary": [],
                "roleSecondaryJp": [],
                "pronouns":"she/her",
                "pronounsJp":"",
                "country":"ca"
            },
            {
                "name": "Jun",
                "slug": "jun",
                "bio": "Hi, I’m Jun! I am the co-director and character designer of Dream Flower Idols! I created the group with my best friend and partner in crime Lotus back in 2021, and we’ve been working hard on this project since then! Aside from this project, I’m a full-time content creator manager, illustrator and graphic designer.",
                "bioJp": "とろゃ留擢すゅ都まのねてせく阿列へんちむひた絵派ゅんややゃるやんふ区樹差派鵜おしねやちぬ二擢ハケマリカ夜夜魔や野鵜課以ねオツヨユ列目やうるやはえねりメレアナ、けらた区二個ロテホネタ、日露ねふゃっふたゆち譜以遊二派遊舳巣けの差二個夜野二む樹離氏キテテミりそ等鵜擢夜つうと氏氏譜列アセオケホユ樹瀬はくみニトマケリ。",
                "color": "#FF8217",
                "link": "https://junjoukun.carrd.co/",
                "socialMedia": 
                    {
                        "x":"https://twitter.com/junjoukun/", 
                        "carrd":"https://junjoukun.carrd.co/", 
                        "twitch": "https://www.twitch.tv/junjoukun"
                    },
                "rolePrimary": "Co-director",
                "rolePrimaryJp": "のねてせく",
                "rolePrimarySlug":"graphics",
                "roleSecondary": ["Character Designer"],
                "pronouns":"he/him",
                "pronounsJp":"",
                "country":"ca"
            }
        ]
    },
    "music": {
        "name": "Musicians",
        "nameJp":"",
        "color": "#CE1735",
        "staff": [
            {
                "name": "Ohara",
                "slug": "ohara",
                "bio": "Hi, I’m Ohara! I’m the main composer for Dream Flower, and also the developer of the website. Music has been a passion of mine ever since I was a little kid playing Zelda games. Outside of Dream Flower, I am a full-time student at KTH Royal Institute of Technology in Sweden. When I am not making music or studying, I like to play video games with my friends. I really hope you’ll enjoy the music I make together with the rest of the team—I put my all into every song!",
                "color": "#CE1735",
                "link": "https://junjoukun.carrd.co/",
                "rolePrimary": "Composer",
                "rolePrimarySlug":"composer",
                "roleSecondary": ["Mixer", "Web developer"],
                "roleSecondaryJp": [],
                "socialMedia": {
                    "youtube":"https://youtube.com/@6hara"
                },
                "pronouns":"he/him",
                "pronounsJp":"",
                "country":"se"
            },
            {
                "name": "Geiky",
                "slug": "geiky",
                "bio": "Hello! My name is Geiky and I write lyrics in both English and Japanese for all of Dream Flower’s songs. I love writing lyrics that tell a story and that are filled with wordplay and emotion. Outside of this project, I’m a language teacher and translator/interpreter based in Brazil. I love video-games, linguistics and cooking!",
                "color": "#589C5F",
                "link": "https://junjoukun.carrd.co/",
                "rolePrimary": "Lyricist",
                "rolePrimarySlug":"lyrics",
                "roleSecondary": [],
                "socialMedia": {
                    "x":"https://x.com/Geikroitz"
                },
                "pronouns":"he/him",
                "pronounsJp":"",
                "country":"br"
            },
            {
                "name": "Jenn",
                "slug": "jenn",
                "bio": "Hello, I’m Jenn! I’m in charge of vocal editing for many of Dream Flower’s songs. Outside the project, I’m also a vocalist who specializes in mixing and creating vocal arrangements! My goal is to help everyone feel confident and happy with their music!!",
                "color": "#ab74d5",
                "link": "https://junjoukun.carrd.co/",
                "rolePrimary": "Vocal editor",
                "rolePrimarySlug":"timetune",
                "roleSecondary": [],
                "socialMedia": {
                    "x":"https://x.com/jennacraa"
                },
                "pronouns":"she/her",
                "country":"us"
            }
        ]
    },
    "writers": {
        "name": "Writers",
        "color": "#EC92EA",
        "staff": [
            {
                "name": "Linnea",
                "slug": "keiko",
                "bio": "Hi there! I’m Linnea, a freelance manga artist and writer based in Tokyo. I am the lead writer and storyboard artist for the upcoming Dream Flower manga. I also work full time in the Japanese anime industry as an animator and key frame supervisor. We hope you enjoy our work!",
                "color": "#EC92EA",
                "link": "https://linneakataja.com/",
                "rolePrimary": "Lead writer",
                "rolePrimarySlug":"writer",
                "roleSecondary": [],
                "pronouns":"she/her",
                "pronounsJp":"",
                "country":"us",
                "socialMedia": {
                    "x": "https://x.com/KeikoKup"
                }
            }          
        ]
    },
    "editors": {
        "name": "Video Editors",
        "color": "#E86F88",
        "staff": [
            {
                "name": "Andy",
                "slug": "andy",
                "bio": "Heya! I’m Andy. I am an editor and motion designer for Dream Flower’s music videos. In my free time, I enjoy tinkering with various arts and crafts and enjoy various types of teas & baking. I do motion design full time and it’s one of my greatest loves & passions. I hope you enjoy. ",
                "color": "#E86F88",
                "link": "https://junjoukun.carrd.co/",
                "rolePrimary": "Video editor",
                "rolePrimarySlug":"animation",
                "roleSecondary": [],
                "pronouns":"she/they",
                "pronounsJp":"",
                "country":"au",
                "socialMedia": {
                    "x":"https://x.com/alderwicked"
                },
            },
            {
                "name": "Envy",
                "slug": "envy",
                "bio": "Hello, I'm Envy, a Motion Graphics Artist. I started learning video editing around 2020, beginning with creating AMVs (Anime Music Videos), then moving on to MMVs (Manga Music Videos). To this day, I continue to learn independently and self-taught. I never expected to have the opportunity to join Dream Flower’s as a video editor.",
                "color": "#B6B6B6",
                "link": "https://envyyy.carrd.co/",
                "rolePrimary": "Video editor",
                "rolePrimarySlug":"animation",
                "roleSecondary": [],
                "pronouns":"he/him",
                "socialMedia": { 
                    "x":"https://twitter.com/envyyer", 
                    "carrd":"https://envyyy.carrd.co/" 
                },
                "country":"id"
            }
        ]
    }
}
